import React from 'react';
import styled from '@benzinga/themetron';
import { isMobile } from '@benzinga/device-utils';
import { footerStickyNavigation } from './footerEntity';

export const FooterStickyNav: React.FC = () => {
  return (
    isMobile() && (
      <Container className="sticky-footer">
        <div className="footer-actions">
          {footerStickyNavigation.map((item, i: number) => {
            return (
              <div className="footer-quick-link" key={i}>
                <a data-action={`Footer Sticky Nav Click - ${item.label}`} href={item.url}>
                  <div className="icon-wrap">
                    <img alt={item.label} src={item.image} />
                  </div>
                  <h6>{item.label}</h6>
                </a>
              </div>
            );
          })}
        </div>
      </Container>
    )
  );
};

export default FooterStickyNav;

const Container = styled.div`
  &.sticky-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    border-top: 1px solid #ddd;
    box-shadow:
      transparent 0px 0px,
      transparent 0px 0px,
      rgb(163 163 163 / 50%) 0px 0px 15px 5px;
    z-index: 99;
    .footer-actions {
      display: flex;
      background: white;
      align-items: center;
      flex-wrap: nowrap;
      overflow: auto;
      padding: 8px 0;
      justify-content: space-between;
      align-items: flex-start;
      .footer-quick-link {
        min-width: 25%;
        display: block;
        text-align: center;
        .icon-wrap {
          width: 40px;
          height: 40px;
          margin: 0 auto;
          border-radius: 50%;
          display: flex;
          align-items: center;
          img {
            width: 100%;
            height: 100%;
            margin: 0 auto;
          }
        }
        h6 {
          font-size: 11px;
          padding-top: 6px;
        }
      }
    }
  }
`;
